import React from 'react';
import {
  Row,
  Col,
} from 'react-bootstrap';
import { List, Map } from 'immutable';
import ElementBuilder from './elements/ElementBuilder.jsx';
import { connect } from 'react-redux';
import { refLoad } from '@/component/dict/complex/product/store';
import { REF_NAME, REF_PATH } from '@/component/dict/complex/product/Const';
import 'rc-select/assets/index.css';
import { getDealListWrapper } from './store/DealsWrapper';
import { clearQuantity, setQuantity, setLinkSavingAllowed } from '@/store/links.store.js';

class AtomsQuantity extends React.Component {
  constructor(props) {
    super(props);
    this.filterData = this.filterData.bind(this);
    this.resize = this.resize.bind(this);
    this.state = {
      originalData: undefined,
      data: undefined,
      filter: undefined,
      total: 0,
    };
  }
  componentWillMount() {
    getDealListWrapper(this.props.dealFrom);
    getDealListWrapper(this.props.dealTo, 'INF');
    if (this.props.data) {
      this.filterData(this.props);
    }
    this.props.clearQuantity();
  }
  componentDidMount() {
    window.addEventListener('resize', this.resize);
  }
  componentWillReceiveProps(props) {
    if (props.selectedAtoms != this.props.selectedAtoms && props.data != this.props.data) {
      this.filterData(props);
    }

    if (props.productTypeFilter &&
        props.quantityOrder.toJS() != this.props.quantityOrder.toJS() &&
      props.quantities.toJSON() != this.props.quantities.toJSON()) {
      let linkedQ = 0;
      linkedQ += props.productTypeFilter.get('saleLink', new List()).filter(l => !l.get('hidden'))
        .reduce((sum, l) => sum +
        parseFloat(l.get('billLandingQuantity') || l.get('quantityMin') || 0), 0);
      linkedQ += props.productTypeFilter.get('purchaseLink', new List())
        .filter(l => !l.get('hidden'))
        .reduce((sum, l) => sum +
        parseFloat(l.get('billLandingQuantity') || l.get('quantityMin') || 0), 0);
      const max = parseFloat(props.productTypeFilter.get('quantityMax') || 0) - linkedQ;
      let totalMin = 0;
      let savingAllowed = true;
      props.quantityOrder.reverse().forEach((quantId) => {
        let q = props.quantities.get(quantId);
        if (q) {
          q = q.toJS();
          if (q && !q.failed && !q.groupCheckFailed) {
            const qMin = q.min ? Number.parseFloat(q.min) : 0;
            if (totalMin + qMin > max) {
              this.props.setQuantity(quantId, { groupCheckFailed: true });
              savingAllowed = false;
            } else {
              if (q.groupCheckFailed === true) {
                this.props.setQuantity(quantId, { groupCheckFailed: false });
              }
              totalMin += qMin;
            }
          } else if (q && q.failed) {
            savingAllowed = false;
          }
        }
      });
      props.quantityOrder.reverse().forEach((quantId) => {
        let q = props.quantities.get(quantId);
        if (q) {
          q = q.toJS();
          const qMin = q.min ? Number.parseFloat(q.min) : 0;
          if (q && !q.failed && q.groupCheckFailed) {
            if (totalMin + qMin <= max) {
              this.props.setQuantity(quantId, { groupCheckFailed: false });
              totalMin += qMin;
            } else {
              savingAllowed = false;
            }
          }
        }
      });
      this.props.setLinkSavingAllowed(savingAllowed);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  getDataToDisplay(data, type) {
    return data
      .map((elem, id) => (
        <ElementBuilder
          dealIdx={id}
          key={`atom-${id}`}
          data={elem}
          multiNodalQuantity={this.props.multiNodalQuantity}
          type={`connect${type}`}
          mode="quantity"
          id={id}
        />
      )).toArray();
  }


  resize() {
    this.forceUpdate();
  }


  filterData(props) {
    let data = props.data ? props.data : new List();
    if (this.props.selectedAtoms.size !== 0) {
      let atoms = new List();
      data.forEach((objectToCheck) => {
        let deal = objectToCheck;
        const dealid = deal.get('id');
        if (this.props.selectedAtoms.has(dealid)) {
          const values = this.props.selectedAtoms.get(dealid);
          const products = deal.get('products');
          const filteredProducts = products.filter(product =>
            values.has(product.get('id')));
          if (filteredProducts.size !== 0) {
            deal = deal
              .delete('products')
              .set('products', filteredProducts);
            atoms = atoms.push(deal);
          }
        }
      });
      data = atoms;
    }
    this.setState({
      originalData: data,
      data: this.getDataToDisplay(data, props.dealTo),
      total: data.size,
    });
  }

  render() {
    if (this.props.dealFrom == 'purchase') {
      return (
        <div className="deals deals-link-page">
          <Col md={4} style={{ paddingRight: 20 }}>
            {this.props.parentAtom}
          </Col>
          <Col md={8} style={{ paddingLeft: 20 }}>
            <Row>
              <Col md={12} className="deals-container">
                <div>
                  <Row>
                    <Col md={12}>
                      {this.state.data ?
                        this.state.data
                        : <span />}
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>
        </div>
      );
    }
    return (
      <div className="deals  deals-link-page">
        <Col md={8} style={{ paddingLeft: 20 }}>
          <Row>
            <Col md={12} className="deals-container">
              <div>
                <Row>
                  <Col md={12}>
                    {this.state.data ?
                      this.state.data
                      : <span />}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Col>
        <Col md={4} style={{ paddingRight: 20 }}>
          {this.props.parentAtom}
        </Col>
      </div>
    );
  }
}

export default connect(
  (store, props) => ({
    selectedAtoms: store.getIn(['links', 'atoms', 'selected'], new Map()),
    // eslint-disable-next-line
    productTypeFilter: store.getIn(['data', 'deals', 'deal', 'products'], new List())
      .get(store.getIn(['links', 'data', 'productToLinkIdx'])),
    data: store.getIn(['data', 'deals', 'list', props.dealTo]),
    quantityOrder: store.getIn(['links', 'order'], new List()),
    quantities: store.getIn(['links', 'quantity'], new Map()),
  })
  , dispatch => ({
    loadProducts() {
      refLoad(dispatch, REF_NAME, REF_PATH);
    },
    setLinkSavingAllowed(bool) {
      setLinkSavingAllowed(dispatch, bool);
    },
    clearQuantity() {
      clearQuantity(dispatch);
    },
    setQuantity(id, quantity) {
      setQuantity(dispatch, id, quantity);
    },
  }))(AtomsQuantity);

AtomsQuantity.propTypes = {
  dealTo: React.PropTypes.string.isRequired,
  dealFrom: React.PropTypes.string.isRequired,
  loadProducts: React.PropTypes.func.isRequired,
  selectedAtoms: React.PropTypes.object.isRequired,
  data: React.PropTypes.object,
  filter: React.PropTypes.object,
  filterBy: React.PropTypes.object,
  clearQuantity: React.PropTypes.func,
  quantityOrder: React.PropTypes.object,
  quantities: React.PropTypes.object,
  setQuantity: React.PropTypes.func,
  setLinkSavingAllowed: React.PropTypes.func,
  parentAtom: React.PropTypes.object,
  multiNodalQuantity: React.PropTypes.number,
};
